import {Component, OnDestroy, OnInit, ViewEncapsulation, Output, EventEmitter, Input} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {select, Store} from '@ngrx/store';
import {ParticleState} from '@shared/store/reducers/particle.reduer';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {takeUntil, skip} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {QueryProvider} from '@shared/queries/query-provider';
import {CreateFilingCommand} from "../../commands/dac6-reporter.command";
import {TimeZoneService} from "@core/services/time-zone.service";
import {DialogService} from "@shared/services/dialog-service";

@Component({
    standalone: false,
    selector: 'particle-create-filing-dialog',
  templateUrl: './create-filing-dialog.component.html',
  styleUrls: ['./create-filing-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreateFilingDialogComponent implements OnInit, OnDestroy, IDialogView {

  data: DialogModel;
  form: FormGroup;
  inputForm: any;
  reportingCountries: any[];
  formTemplates: any[];
  reportingCountryKey = 'DAC6ReportingCountry';
  formTemplateKey = 'DAC6AllFormsByCountry';
  nodeTitle: string;
  existingFormValues: any;
  private reportingCountry$: any;
  private formTemplates$: any;
  private associatedFormTemplates: any;
  private associatedVersions: any;
  private selectedTemplate: any;
  private unsubscribe$ = new Subject<void>();
  private selectedCountryCode: string;
  private filingTypes: any;
  private selectedFilingType: string;
  private filingTypesToFormTemplatesDictionary: any;
  private selectedCategory: any;
  private selectedSubCategory: any;
  inputFormErrors: any;
  formArrangement: boolean;
  versionToolTip: any;
  isSupportedFiling: string;
  private formSourceType: any;
  constructor(private formBuilder: FormBuilder,
              protected particleStore: Store<ParticleState>,
              protected timeZoneService: TimeZoneService,
              private queryStore: Store<IQueryState>,
              private dialogService: DialogService) {
    this.inputFormErrors = {
      reportingCountryCode: {},
      filingType: {},
      formTemplate: {},
      formCategory: {},
      formSubCategory: {},
      title: {},
      dueDate: {}
    };
    this.filingTypes = [];
    this.filingTypesToFormTemplatesDictionary = {
      'Monthly': [],
      'Other': [],
      'Annual': [],
      'Quarterly': []
    };
  }

  ngOnInit() {
    this.nodeTitle = this.data.input['nodeTitle'];
    this.inputForm = this.formBuilder.group({
      reportingCountryCode  : ['', Validators.required],
      filingType  : ['', Validators.required],
      formTemplate  : ['', Validators.required],
      formCategory  : [''],
      formSubCategory  : [''],
      title  : [''],
      dueDate : ['']
    });
    this.existingFormValues = this.data.input['filingFormValues'];
    this.formArrangement = false;
    this.isSupportedFiling = 'Unsure';
    if(this.data.input.fromArrangement){
      this.formArrangement = this.data.input.fromArrangement;
    }

    if(!this.formArrangement){
      this.inputForm.controls['title'].setValidators([Validators.required]);
      this.inputForm.controls['title'].updateValueAndValidity();
      this.inputForm.controls['dueDate'].setValidators([Validators.required]);
      this.inputForm.controls['dueDate'].updateValueAndValidity();
    }

    if(this.existingFormValues){
      if(this.existingFormValues['title']){
        this.inputForm.controls['title'].setValue(this.existingFormValues['title']);
      }
      if(this.existingFormValues['dueDate']){
        this.inputForm.controls['dueDate'].setValue(new Date(this.existingFormValues['dueDate']));
      }
    }

    this.inputForm.valueChanges.subscribe(formValue=>{
      this.onFormValuesChanged();
    });
    this.inputForm.get('reportingCountryCode').valueChanges.subscribe((value) => {
      this.reportingCountryCodeValuesChanged(value);
    });
    this.inputForm.get('filingType').valueChanges.subscribe((value) => {
      this.filingTypeValuesChanged(value);
    });
    this.inputForm.get('formTemplate').valueChanges.subscribe((value) => {
      this.formTemplateValuesChanged(value);
    });
    this.inputForm.get('formCategory').valueChanges.subscribe((value) => {
      this.formCategoryValuesChanged(value);
    });
    this.inputForm.get('formSubCategory').valueChanges.subscribe((value) => {
      this.formSubCategoryValuesChanged(value);
    });
    this.reportingCountry$ = this.queryStore.pipe(select(getQueryResponse, this.reportingCountryKey));
    this.reportingCountry$.pipe(skip(1),takeUntil(this.unsubscribe$)).subscribe(dataState => {
      console.log('items', dataState);
      if (dataState) {
        this.reportingCountries = dataState.items;
        if(this.data.input.arrangementData && this.data.input.arrangementData['CountryToReport']){
          let countryToReport = this.data.input.arrangementData && this.data.input.arrangementData['CountryToReport'];
          this.reportingCountries = this.reportingCountries.filter(rc => rc.countryCode === countryToReport.value);
        }
        if(this.existingFormValues && this.existingFormValues['reportingCountryCode']){
          let selectedCountry = this.reportingCountries.filter(o => o.countryCode === this.existingFormValues['reportingCountryCode']);
          if(selectedCountry.length > 0){
            this.selectedCountryCode = selectedCountry[0].countryCode;
          } else {
            this.selectedCountryCode = this.reportingCountries[0].countryCode;
          }
        } else {
          this.selectedCountryCode = this.reportingCountries[0].countryCode;
        }
        this.inputForm.controls['reportingCountryCode'].setValue(this.selectedCountryCode);
        QueryProvider.invokeQuery(this.queryStore, this.formTemplateKey, {'[countryCode]': this.selectedCountryCode});
      }
    });
    this.formTemplates$ = this.queryStore.pipe(select(getQueryResponse, this.formTemplateKey));
    this.formTemplates$.pipe(skip(1),takeUntil(this.unsubscribe$)).subscribe(dataState => {
      console.log('items', dataState);
      if (dataState) {
        this.formTemplates = dataState.items;
        if(this.data.input.fromArrangement){
          if(this.data.input.arrangementData && this.data.input.arrangementData['Tag'] && this.data.input.arrangementData['Tag'].value){
            let fType = this.convertToFilingType(this.data.input.arrangementData['Tag'].value);
            this.formTemplates = this.formTemplates.filter(ft=>ft.formType === fType);
          }
        }
        if(this.formTemplates && this.formTemplates.length){
          this.filingTypesToFormTemplatesDictionary['Monthly'] = [];
          this.filingTypesToFormTemplatesDictionary['Other'] = [];
          this.filingTypesToFormTemplatesDictionary['Annual'] = [];
          this.filingTypesToFormTemplatesDictionary['Quarterly'] = [];
          this.formTemplates.forEach(ft=>{
            this.filingTypesToFormTemplatesDictionary[ft.formType].push(ft);
          });
          this.filingTypes = [];
          this.filingTypes = this.formTemplates.map(ft=>ft.formType).filter((value, index, self) => self.indexOf(value) === index).sort();
          let isFound = false;
          if(this.existingFormValues && this.existingFormValues['filingType']){
            let existingFilingType = this.filingTypes.filter( o => o === this.existingFormValues['filingType']);
            if(existingFilingType.length > 0){
              this.inputForm.controls['filingType'].setValue(existingFilingType[0]);
              isFound = true;
            }
          }
          if(!isFound){
            if(this.filingTypes.includes('Monthly')){
              this.inputForm.controls['filingType'].setValue(this.filingTypes.find(ft => ft === 'Monthly'));
            }
            else{
              this.inputForm.controls['filingType'].setValue(this.filingTypes[0]);
            }
          }
          this.filingTypeValuesChanged(this.inputForm.controls['filingType'].value);
          this.isSupportedFiling = 'Yes';
        }
        else{
          this.isSupportedFiling = 'No';
        }
      }
    });
    let basketIdFromEat = this.data.input['basketId'];
    if(basketIdFromEat) {
      QueryProvider.invokeQuery(this.queryStore, this.reportingCountryKey, {'[basketId]': basketIdFromEat});
    } else {
      QueryProvider.invokeQuery(this.queryStore, this.reportingCountryKey, {});
    }
  }

  convertToFilingType(type: string){
    if(type === 'Yearly') return 'Annual';
    return type;
  }
  onFormValuesChanged() {
    for (const field in this.inputFormErrors) {
      if (!this.inputFormErrors.hasOwnProperty(field)) {
        continue;
      }
      this.inputFormErrors[field] = {};
      const control = this.inputForm.get(field);
      if (control && control.dirty && !control.valid) {
        this.inputFormErrors[field] = control.errors;
      }
    }
    this.data.isDisabledOkButton = !this.inputForm.valid;
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onOkClicked(): boolean {
    //#region "This block has been refactored. Kept for safety"
    this.data.input['reportingCountryCode'] = this.inputForm.controls['reportingCountryCode'].value;
    this.data.input['filingType'] = this.inputForm.controls['filingType'].value;
    this.data.input['formTemplate'] = this.inputForm.controls['formTemplate'].value;
    this.data.input['title'] = this.inputForm.controls['title'].value;
    this.data.input['dueDate'] = this.inputForm.controls['dueDate'].value;
    //#endregion
    if (this.inputForm.value.formTemplate) {
      this.data.input['filingSourceType'] = this.formTemplates.find(item => item.formId === this.inputForm.value.formTemplate.formId).filingSourceType;
      this.formSourceType = this.data.input['formSourceType'] = this.formTemplates.find(item => item.formId === this.inputForm.value.formTemplate.formId).formSourceType;
    }

    let category = JSON.parse(JSON.stringify(this.inputForm.controls['formCategory'].value));
    if(category){
      category['subCategory'] = [];
      category.subCategory.push(this.inputForm.controls['formSubCategory'].value);
    }
    if(category && category['subCategory'] && category['subCategory'][0] && !category['subCategory'][0].isImplemented){
      this.dialogService.showDialogMessage('Warning!', category['subCategory'][0].showMessage);
    }
    else{
      if(this.data.input.fromArrangement){
        this.data.input['formVersionData'] = {
          'reportingCountryCode': this.inputForm.controls['reportingCountryCode'].value,
          'filingType': this.inputForm.controls['filingType'].value,
          'formName': this.selectedCategory?this.selectedSubCategory.title:this.selectedTemplate.displayText,
          'formTemplateId': this.inputForm.controls['formTemplate'].value.formId
        }
        if(category) this.data.input['formVersionData']['category'] = category;
      }
      else{
        this.getFilingFormValues();
        this.data.input['CreateFilingCommand'] = new CreateFilingCommand(
          this.inputForm.controls['reportingCountryCode'].value,
          this.inputForm.controls['filingType'].value,
          this.selectedCategory?this.selectedSubCategory.title:this.selectedTemplate.displayText,
          this.inputForm.controls['formTemplate'].value.formId,
          category,
          this.inputForm.controls['title'].value,
          new Date(this.timeZoneService.dateTostringWithoutUTC(this.inputForm.controls['dueDate'].value)));
      }
      return true;
    }
  }

  getFilingFormValues(){
    let filingFormValues = {};
    filingFormValues['reportingCountryCode'] = this.inputForm.controls['reportingCountryCode'].value;
    filingFormValues['filingType'] = this.inputForm.controls['filingType'].value;
    filingFormValues['formTemplate-formId'] = this.inputForm.controls['formTemplate'].value.formId;
    filingFormValues['formTemplate-displayText'] = this.selectedTemplate.displayText;
    filingFormValues['title'] = this.inputForm.controls['title'].value;
    filingFormValues['dueDate'] = this.inputForm.controls['dueDate'].value;
    filingFormValues['formSourceType'] = this.formSourceType;
    filingFormValues['dueDateToStringWithOutUTC'] = new Date(this.timeZoneService.dateTostringWithoutUTC(this.inputForm.controls['dueDate'].value));
    if(this.selectedCategory && this.selectedCategory != ''){
      filingFormValues['formCategory-order'] = this.selectedCategory.order;
      filingFormValues['formSubCategory-id'] = this.selectedSubCategory.id;
    }
    this.data.input['filingFormValues']  = filingFormValues;
  }

  private reportingCountryCodeValuesChanged(value: any) {
    this.selectedCountryCode = value;
    QueryProvider.invokeQuery(this.queryStore, this.formTemplateKey, {'[countryCode]': this.selectedCountryCode});
  }

  private filingTypeValuesChanged(value: any){
    this.selectedFilingType = value;
    this.associatedFormTemplates = this.filingTypesToFormTemplatesDictionary[this.selectedFilingType];
    let selectedformTemplate = this.associatedFormTemplates.filter(t => t.isDefaultVersion === true)[0];
    if(this.existingFormValues && this.existingFormValues['formTemplate-formId']){
      let existingFormTemplate = this.associatedFormTemplates.filter( t => t.formId === this.existingFormValues['formTemplate-formId']);
      if(existingFormTemplate.length > 0){
        selectedformTemplate = existingFormTemplate[0];
      }
    }
    this.inputForm.controls['formTemplate'].setValue(selectedformTemplate);
    this.formTemplateValuesChanged(this.inputForm.controls['formTemplate'].value);
  }
  private formTemplateValuesChanged(value: any){
    this.selectedTemplate = value;
    this.setVersionToolTip();
    if(this.selectedTemplate.category && this.selectedTemplate.category.length > 0){
      let selectedCategory = this.selectedTemplate.category[0];
      if(this.existingFormValues && this.existingFormValues['formCategory-order']){
        let existingCategory = this.selectedTemplate.category.filter(o => o.order === this.existingFormValues['formCategory-order']);
        if(existingCategory.length > 0){
          selectedCategory = existingCategory[0];
        }
      }
      this.inputForm.controls['formCategory'].setValue(selectedCategory);
    }
    else{
      this.inputForm.controls['formCategory'].setValue('');
    }
    this.formCategoryValuesChanged(this.inputForm.controls['formCategory'].value);
  }

  setVersionToolTip(){
    this.versionToolTip = '';
    if(this.selectedTemplate && this.selectedTemplate.metaData && this.selectedTemplate.metaData.length > 0
    ){
      let val = this.selectedTemplate.metaData.filter(x=> x.Key === 'VersionToolTip');
      if(val && val.length && val[0].Value && val[0].Value.toString().length){
        this.versionToolTip = val[0].Value.toString();
      }
    }
  }

  private formCategoryValuesChanged(value: any){
    this.selectedCategory = value;
    if(this.selectedCategory && this.selectedCategory.subCategory){
      let subCategory = this.selectedCategory.subCategory.filter(sc => sc.id === this.selectedCategory.defaultSubCategory)[0];
      if(this.existingFormValues && this.existingFormValues['formSubCategory-id'] ){
        let existingSubCategory = this.selectedCategory.subCategory.filter(o => o.id === this.existingFormValues['formSubCategory-id']);
        if(existingSubCategory.length > 0){
          subCategory = existingSubCategory[0];
        }
      }
      this.inputForm.controls['formSubCategory'].setValue(subCategory);
    }
    else{
      this.inputForm.controls['formSubCategory'].setValue('');
    }
    this.formSubCategoryValuesChanged(this.inputForm.controls['formSubCategory'].value);
  }

  private formSubCategoryValuesChanged(value: any){
    this.selectedSubCategory = value;
  }
  handleNodeTitleChange(key: string, value: string | number) {
    this.data.input[key] = value;
  }
}
